import { render, staticRenderFns } from "./alt-auto-button.vue?vue&type=template&id=06a96182&scoped=true&"
import script from "./alt-auto-button.ts?vue&type=script&lang=ts&"
export * from "./alt-auto-button.ts?vue&type=script&lang=ts&"
import style0 from "./alt-auto-button.vue?vue&type=style&index=0&id=06a96182&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a96182",
  null
  
)

export default component.exports